import moment from 'moment/moment'

import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { Feature } from './Feature'
import { Field } from './Field'
import { FKType } from './SQLBuilder'

type CriteriaConstructorArgs = ConstructorArgs<() => Criteria>

export class Criteria extends BaseRecord {
    readonly recordType = 'criteria'

    type?: string
    memo?: string
    title?: string
    caption?: string
    grouping?: string
    cancelledDate?: moment.Moment
    lastModifiedDate?: moment.Moment

    constructor(data?: Partial<CriteriaConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.type = data.type ?? undefined
        this.memo = data.memo ?? undefined
        this.title = data.title ?? undefined
        this.caption = data.caption ?? undefined
        this.grouping = data.grouping ?? undefined
        this.cancelledDate = this.propertyFromTimestampArg(data.cancelled_date)
        this.lastModifiedDate = this.propertyFromTimestampArg(data.last_modified_date)
    }

    clone(overrides?: Partial<CriteriaConstructorArgs>): Criteria {
        return new Criteria({ ...this.serializeForClone(), ...overrides })
    }

    static groupingOrder: string[] = ['income', 'booking', 'client']

    static fk: FKType = {
        fields: ['field'],
        features: ['feature'],
    }

    static dataType(): DataType {
        return 'criterias'
    }

    get field(): Field | undefined {
        return this.getForeignRecord('field', Field)
    }
    set field(field: Field | undefined) {
        this.setForeignRecord('field', field)
    }
    get feature(): Feature | undefined {
        return this.getForeignRecord('feature', Feature)
    }
    set feature(feature: Feature | undefined) {
        this.setForeignRecord('feature', feature)
    }
}
